import React from 'react';
import Preloader from '../Assets/Images/preloader.webp'

const PreLoader = () => {
  return (
    <div className="pre-loader">
        <img src={Preloader} alt="" className="img-fluid preloader" />
    </div>
  );
};

export default PreLoader;
